"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceKitComponentsSchema = exports.updateKitMasterSchema = exports.createKitMasterSchema = exports.kitMasterShape = exports.kitComponentSchema = exports.kitComponentShape = void 0;
const zod_1 = require("zod");
exports.kitComponentShape = {
    drugId: zod_1.z.string().uuid().optional(),
    itemId: zod_1.z.string().uuid().optional(),
    requiredQuantity: zod_1.z.number().positive(),
    isOptional: zod_1.z.boolean().default(false),
    substituteGroupId: zod_1.z.string().uuid().optional(),
    sortOrder: zod_1.z.number().int().nonnegative(),
    notes: zod_1.z.string().optional(),
};
exports.kitComponentSchema = zod_1.z.object(exports.kitComponentShape);
exports.kitMasterShape = {
    kitCode: zod_1.z.string().min(1).max(30).optional(),
    kitName: zod_1.z.string().min(1).max(255),
    kitTypeId: zod_1.z.string().uuid().optional(),
    barcodeValue: zod_1.z.string().max(100).optional(),
};
exports.createKitMasterSchema = zod_1.z.object({
    ...exports.kitMasterShape,
    components: zod_1.z.array(exports.kitComponentSchema).default([]),
});
exports.updateKitMasterSchema = zod_1.z.object(exports.kitMasterShape).partial();
exports.replaceKitComponentsSchema = zod_1.z.object({ components: zod_1.z.array(exports.kitComponentSchema) });
//# sourceMappingURL=kit-master.schema.js.map